import styled from 'styled-components';
import IconArrowDownCircleOutline from './IconArrowDownCircleOutline';
var IconArrowLeftCircleOutline = /*#__PURE__*/styled(IconArrowDownCircleOutline).withConfig({
  displayName: "IconArrowLeftCircleOutline",
  componentId: "c11n-8-111-1__sc-mk3kt1-0"
})(["transform:rotate(90deg);"]);
export default IconArrowLeftCircleOutline;